/** @format */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { Bar } from 'react-chartjs-2';
import COLORS from '../../../../assets/themes/OPL/colors';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import I18n from '../../../../core/i18n';

const useStyles = makeStyles({
    ...adescomStyle,
    chartCard: {
        backgroundColor: '#1a1a1a',
        color: COLORS.MAIN.LIGHT,
        height: '100%',
        border: `1px solid ${COLORS.MAIN.PRIMARY}`,
    },
    chartCardHeader: {
        backgroundColor: '#000',
        borderBottom: `2px solid ${COLORS.MAIN.PRIMARY}`,
        padding: '12px 16px',
        '& .MuiCardHeader-title': {
            color: COLORS.MAIN.LIGHT,
            fontWeight: 'bold',
            fontSize: '1rem',
        },
        '& .MuiCardHeader-subheader': {
            color: COLORS.MAIN.PRIMARY,
            fontSize: '0.85rem',
        },
    },
    chartContent: {
        padding: '16px',
        minHeight: '300px',
    },
});

interface ChartCardProps {
    title: string;
    totalBlocks: number;
    chartData: any;
    chartOptions: any;
    chartPlugins: any[];
    hasData: boolean;
    chartHeight: number;
}

const ChartCard: React.FC<ChartCardProps> = ({
    title,
    totalBlocks,
    chartData,
    chartOptions,
    chartPlugins,
    hasData,
    chartHeight,
}) => {
    const classes = useStyles();

    return (
        <Card className={classes.chartCard}>
            <CardHeader
                className={classes.chartCardHeader}
                title={title}
                subheader={`${I18n.t('specialized_report:dashboard.total_blocks')}: ${totalBlocks.toLocaleString()}`}
            />
            <CardContent className={classes.chartContent}>
                {hasData ? (
                    <div style={{ height: `${chartHeight}px` }}>
                        <Bar data={chartData} options={chartOptions} plugins={chartPlugins} />
                    </div>
                ) : (
                    <div
                        style={{
                            height: '350px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: COLORS.MAIN.LIGHT,
                            fontSize: '16px',
                        }}
                    >
                        {I18n.t('specialized_report:dashboard.no_data')}
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default ChartCard;
